import axios from 'axios';
import { urlAPI } from '../configurations/constantes';

class CarroConectadoService {
    static obterLink = () => {
        const ud = JSON.parse(localStorage.getItem('user_data'));
        return axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/carro_conectado`)
    }
}

export default CarroConectadoService; 